<!-- @veltra/icons generated sha256:100e0a587feb690b gen:8 source:src/svg/normal/history.svg -->
<script setup lang="ts">
defineOptions({ name: 'History' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M13.21 8.002c0-2.862-2.36-5.209-5.304-5.209a5.32 5.32 0 0 0-4.501 2.454h1.45a.51.51 0 0 1 .523.506v.012a.535.535 0 0 1-.534.526H2.251a.5.5 0 0 1-.5-.5V3.154c0-.287.217-.51.504-.51h.011c.287 0 .524.239.524.526v1.134a6.37 6.37 0 0 1 5.116-2.552c3.504 0 6.345 2.798 6.345 6.25s-2.84 6.25-6.345 6.25c-2.764 0-5.115-1.74-5.986-4.17a.49.49 0 0 1 .394-.646l.008-.001c.265-.044.514.124.61.376.746 1.978 2.683 3.399 4.974 3.399 2.944 0 5.303-2.347 5.303-5.208M7 8.389V5.993c0-.276.227-.493.496-.493.276 0 .504.235.504.511v1.964l2.002 2.002a.5.5 0 0 1-.005.707l-.008.008a.486.486 0 0 1-.695-.009z"
    />
  </svg>
</template>
